import React from 'react';
import { Link } from 'react-router-dom';
const destinations = [{
  id: 1,
  name: 'Bali',
  image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
  price: 'From $599',
  type: 'Flight + Hotel'
}, {
  id: 2,
  name: 'Paris',
  image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1173&q=80',
  price: 'From $699',
  type: 'Flight + Hotel'
}, {
  id: 3,
  name: 'Tokyo',
  image: 'https://images.unsplash.com/photo-1503899036084-c55cdd92da26?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
  price: 'From $899',
  type: 'Flight + Hotel'
}, {
  id: 4,
  name: 'New York',
  image: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
  price: 'From $499',
  type: 'Flight + Hotel'
}];
const FeaturedDestinations = () => {
  return <section className="py-12 bg-white" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-12" data-id="element-26">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-27">
            Featured Destinations
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-28">
            Discover our most popular vacation packages
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-29">
          {destinations.map(destination => <Link key={destination.id} to={`/search?type=package&to=${destination.name}`} className="group" data-id="element-30">
              <div className="relative rounded-lg overflow-hidden shadow-lg h-64" data-id="element-31">
                <img src={destination.image} alt={destination.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-32" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" data-id="element-33"></div>
                <div className="absolute bottom-0 left-0 p-4 text-white" data-id="element-34">
                  <h3 className="text-xl font-bold" data-id="element-35">{destination.name}</h3>
                  <p className="text-sm opacity-90" data-id="element-36">{destination.type}</p>
                  <p className="mt-1 font-semibold text-blue-300" data-id="element-37">
                    {destination.price}
                  </p>
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
};
export default FeaturedDestinations;